(function() { window.GUID_ce19e330_1403_4a54_b373_88d9b0715e74 = { getGuid: function() { return "ce19e330-1403-4a54-b373-88d9b0715e74"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class PersonaDropdown extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$Dropdown;
            }
            get $Dropdown() {
                return $(`#${this.ControlId}`);
            }
            get $Picker() {
                return $(`*[data-pickerof="dropdown-${this.ControlId}"]`);
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
            }
            OnBindEvents() {
                const controller = CS.CommonData.Current.Navigation.Controller;
                const shouldBindEvents = controller != "personawall" &&
                    controller != "eventswallv2" &&
                    controller != "operatorswall" &&
                    controller != "gameswall" &&
                    controller != "divisionswall" &&
                    controller != "awardswall" &&
                    controller != "streamswall" &&
                    controller != "rankingswall" &&
                    controller != "teamswall";
                if (shouldBindEvents) {
                    CS.Controls.DropDownPicker.Events.SelectionChanged({
                        selector: "#autocomplete-find-players-persona-drpdwn-subtop",
                        callback: (picker, e) => this.goToPersonaUrl(e),
                    });
                    CS.Controls.DropDownPicker.Events.SelectionChanged({
                        selector: "#autocomplete-find-opponents-persona-drpdwn-subtop",
                        callback: (picker, e) => this.goToPersonaUrl2(e),
                    });
                    CS.Controls.DropDownPicker.Events.SelectionChanged({
                        selector: "#autocomplete-find-players-persona-drpdwn-topbar",
                        callback: (picker, e) => this.goToPersonaUrl(e),
                    });
                    CS.Controls.DropDownPicker.Events.SelectionChanged({
                        selector: "#autocomplete-find-opponents-persona-drpdwn-topbar",
                        callback: (picker, e) => this.goToPersonaUrl2(e),
                    });
                    CS.Controls.DropDownPicker.Events.ListItemClicked({
                        selector: "#dropdown-persona-drpdwn-topbar",
                        callback: (list, e) => {
                            const { extraValues } = e.data;
                            if (extraValues != null) {
                                const { PersonaWallSelectorUrl } = extraValues;
                                if (!CS.Helper.isNullOrWhiteSpace(PersonaWallSelectorUrl)) {
                                    Controls.Popup.ShowAjaxModal(PersonaWallSelectorUrl, {}, ({ popup }) => {
                                        // On load
                                    }, ({ popup }) => {
                                        // On close
                                    }, true, false);
                                }
                            }
                        },
                    });
                }
                // TODO : Créer un control avec la VersusCard et gérer le callback dans ce control
                CS.Controls.DropDownPicker.Events.SelectionChanged({
                    selector: "#autocomplete-find-players-persona-drpdwn-vs-card-event-wall",
                    callback: (picker, e) => this.goToCompareUrl(e),
                });
                CS.Controls.DropDownPicker.Events.SelectionChanged({
                    selector: "#autocomplete-find-players-persona-drpdwn-vs-card-stats-compare",
                    callback: (picker, e) => this.goToCompareUrl(e),
                });
                CS.Controls.DropDownPicker.Events.SelectionChanged({
                    selector: "#autocomplete-find-players-persona-drpdwn-vs-card-stats-compare-1",
                    callback: (picker, e) => this.goToCompareUrl2(e),
                });
                CS.Controls.DropDown.Events.ListItemClicked({
                    selector: ".dropdown.no-result-content",
                    callback: (dd, e) => {
                        var dropdown = dd;
                        dropdown.CurrentPicker.OnSelectionChange([e.data]);
                        dropdown.CurrentPicker.Datas = dropdown.SelectedDatas;
                    },
                });
            }
            OnDispose() { }
            OnControlRendered() {
                this.setPlayerNameWidth();
            }
            setPlayerNameWidth() {
                // Lorsque le nom est long, il s'étale sur 2 lignes, mais le "display:flex" fait que
                // l'icône de "chevron-down" est parfois très loin..
                // Pour éviter que l'utilisateur soit mélangé, on limite la taille du nom
                // Pour que ce soit évident que le "chevron-down" est associé au nom
                // TODO : Lorsqu'on aggrandi la fenêtre (e.g. on rotationne le téléphone), on pourrait
                // remettre full-width puisqu'il y aura alors de l'espace pour afficher le nom
                // sur une seule ligne.
                const $nameContainer = this.$Picker.find(".player-name-container");
                if ($nameContainer.length > 0) {
                    const $name = $nameContainer.find(".player-name");
                    if ($name.length > 0) {
                        const width = $name.outerWidth();
                        if (width > 0) {
                            $nameContainer.css({
                                "max-width": `${width + 10}px`,
                            });
                        }
                    }
                }
            }
            goToPersonaUrl(e) {
                const data = e.data;
                if (data != null) {
                    const { value: entityBaseId, extraValues } = data[0];
                    if (entityBaseId != null && extraValues != null) {
                        const { url, PersonaWallSelectorUrl } = extraValues;
                        if (!CS.Helper.isNullOrWhiteSpace(PersonaWallSelectorUrl)) {
                        }
                        else if (!CS.Helper.isNullOrWhiteSpace(url)) {
                            CS.Nav.Go(url, null, CS.Nav.Source.Post);
                        }
                    }
                }
            }
            goToPersonaUrl2(e) {
                const data = e.data;
                if (data != null) {
                    const { value: entityBaseId, extraValues } = data[0];
                    if (entityBaseId != null && extraValues != null) {
                        const { url2, PersonaWallSelectorUrl } = extraValues;
                        if (!CS.Helper.isNullOrWhiteSpace(PersonaWallSelectorUrl)) {
                            console.log("PersonaWallSelectorUrl");
                        }
                        else if (!CS.Helper.isNullOrWhiteSpace(url2)) {
                            CS.Nav.Go(url2, null, CS.Nav.Source.Post);
                        }
                    }
                }
            }
            goToCompareUrl(e) {
                console.log("goToCompareUrl");
                const data = e.data;
                if (data != null && data[0] != null) {
                    const { value: entityBaseId, extraValues } = data[0];
                    if (entityBaseId != null && extraValues != null) {
                        if (extraValues != null) {
                            CS.Nav.Go(extraValues.url, null, CS.Nav.Source.Post, true);
                        }
                    }
                }
            }
            goToCompareUrl2(e) {
                const data = e.data;
                if (data != null && data[0] != null) {
                    const { value: entityBaseId, extraValues } = data[0];
                    if (entityBaseId != null && extraValues != null) {
                        if (extraValues != null) {
                            CS.Nav.Go(extraValues.url2, null, CS.Nav.Source.Post, true);
                        }
                    }
                }
            }
        }
        Controls.PersonaDropdown = PersonaDropdown;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=persona-dropdown.js.map
